/**
 * Errors List Subcommand
 */
import { Command } from 'commander';
import chalk from 'chalk';
import Table from 'cli-table3';
import { ErrorLogService } from '../../services/error-log.service.js';

export function createErrorsListSubcommand(): Command {
  return new Command('list')
    .description('Danh sách error logs')
    .option('--json', 'Output JSON format')
    .action(async (options: { json?: boolean }) => {
      const service = new ErrorLogService();
      const paths = await service.list();

      if (paths.length === 0) {
        if (options.json) {
          console.log(JSON.stringify({ logs: [] }, null, 2));
        } else {
          console.log('✨ Không có error logs nào.');
        }
        return;
      }

      const logs = [] as Array<{ id: string; timestamp?: string; command?: string; message?: string }>;
      for (const path of paths) {
        const read = await service.readLog(path);
        if (read) {
          logs.push({
            id: path.split('/').pop()?.replace(/\.json$/, '') || path,
            timestamp: read.entry.timestamp,
            command: read.entry.command,
            message: read.entry.message,
          });
        }
      }

      if (options.json) {
        console.log(JSON.stringify({ logs }, null, 2));
        return;
      }

      const table = new Table({
        head: ['ID', 'Timestamp', 'Command', 'Message'],
        colWidths: [36, 26, 16, 60],
        wordWrap: true,
      });

      for (const log of logs) {
        table.push([
          chalk.cyan(log.id),
          log.timestamp || '-',
          log.command || '-',
          log.message || '-',
        ]);
      }

      console.log(table.toString());
    });
}
